'use strict';

angular.module('core').controller('MapsController', ['$scope',
	function($scope) {
		// Maps controller logic
		// ...
	}
]);